// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d34ab6f","479":"85fd96e3","578":"5d0689fe","858":"602bdab8","931":"257292a5","954":"0efd4df7","984":"340c4cdd"}[chunkId] + ".chunk.js";
};